import { Box, Image } from "@oneloop/jopijs";
import React from "react";
import { useSelector } from "react-redux";
import { isTrue } from "../../../utilities/helpers";
import BranchSection from "./BranchSection";

export default function InmobiliarySection({ enabled }) {
  const { branch, showData, isEdition, edited_data } = useSelector(
    (state) => state.FichaInfoSlice
  );
  const { custom_branch } = edited_data;
  const branch_to_show =
    showData === "origin_data" && !isEdition ? branch : custom_branch ?? branch;

  const {
    company,
    name,
    email,
    phone,
    contact_time,
    alt_phone,
    address,
    logo,
  } = branch_to_show;

  return (
    <Box
      data-enabled={enabled}
      data-testid="show_branch-card"
      __css={{ display: "flex", gap: "16px" }}
    >
      {isTrue(logo) && (
        <Image
          style={{
            minWidth: "48px",
            width: "48px",
          }}
          variant="rows"
          src={logo}
        />
      )}
      <BranchSection
        company_name={company.name}
        branch_name={name}
        email={email}
        phone={phone}
        contact_time={contact_time}
        whatsapp={alt_phone}
        branch_address={address}
      />
    </Box>
  );
}
